import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";

import { IS_FOCUS, OPEN_HAMBURGER_MENU, OPEN_SEARCHBAR } from "../../../store/actions";
import HamburgerMenu from "../../../atoms/hamburger-menu";
import NavbarMenu from "../NavbarMenu";
import { NavbarSearch } from "../navbar-search";
import Hamburger from "../Hamburger";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { Link } from "@quintype/components";

import "./navbar.m.css";

const NavBar = () => {
  const dispatch = useDispatch();
  const getState = useSelector((state) => state);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const navbarMenu = get(getState, ["qt", "data", "navigationMenu", "navbarMenu"], []);
  const hamburgerMenu = get(getState, ["qt", "data", "navigationMenu", "hamburgerMenu"], []);
  const displayStyle = isHamburgerMenuOpen ? "flex" : "none";

  const secondaryMenu = get(getState, ["qt", "data", "navigationMenu", "headerMenu"], []);

  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen,
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
    dispatch({
      type: IS_FOCUS,
      isFocus: false,
    });
  };

  const getHamburger = () => {
    if (!isHamburgerMenuOpen) {
      return null;
    }
    return (
      <Fragment>
        <div styleName="overlay" onClick={() => toggleHandler()}></div>
        <Hamburger
          displayStyle={displayStyle}
          toggleHandler={toggleHandler}
          hamburgerMenu={hamburgerMenu}
          secondaryMenu={secondaryMenu}
        />
      </Fragment>
    );
  };

  return (
    <>
      <div styleName="top-seperator" />
      <div styleName="main-wrapper" id="sticky-navbar">
        <nav styleName="wrapper">
          {hamburgerMenu.length > 0 ? (
            <div styleName="hamburger-wrapper">
              {isHamburgerMenuOpen ? (
                <div onClick={toggleHandler} styleName="close-icon">
                  <SvgIconHandler type="close" width="24" height="24" viewBox="0 0 12 12" />
                </div>
              ) : (
                <HamburgerMenu onMenuToggle={() => toggleHandler()} isMegaMenuOpen={isHamburgerMenuOpen} />
              )}
              <NavbarSearch />
              {getHamburger()}
            </div>
          ) : (
            <div />
          )}
          <Link href="/" aria-label="home page" data-test-id="home-section" styleName="home-icon-wrapper">
            <SvgIconHandler type="black-home-icon" width="24" height="24" viewBox="0 0 24 24" className="home-icon" />
          </Link>
          <NavbarMenu menu={navbarMenu} isHighlighter />
        </nav>
      </div>
    </>
  );
};

export { NavBar };
